import { Route } from 'react-router-dom';
import Bash from '../../Pages/Website/UserHome/Labs/Bash_Scripting/Bash.jsx';
import BASH_QUIZ from '../../Pages/Website/UserHome/Labs/Bash_Scripting/second_lab/Bash_quiz.jsx';
// End Bash Scripting
// Obfuscation
import Obfuscation from '../../Pages/Website/UserHome/Labs/Obfuscation/Obfuscation.jsx';
import OBFUSCATION_LAB from '../../Pages/Website/UserHome/Labs/Obfuscation/Obfuscation_lab.jsx';
import OBFUSCATION_LOGIN from '../../Pages/Website/UserHome/Labs/Obfuscation/Practical/Lab_1/Login.jsx';
import OBFUSCATION_QUIZ from '../../Pages/Website/UserHome/Labs/Obfuscation/Practical/Lab_2/Ob_quiz.jsx';
// End Obfuscation
// CryptoGraphy
import CryptoGraphy from '../../Pages/Website/UserHome/Labs/CryptoGraphy/CryptoGraphy.jsx';
import CRYPTOGRAPHY_LAB from '../../Pages/Website/UserHome/Labs/CryptoGraphy/CryptoGraphy_lab.jsx';
import TOP_SECRET from '../../Pages/Website/UserHome/Labs/CryptoGraphy/Practical/first_lab/Top_secret.jsx';
import DECODE_IMAGE from '../../Pages/Website/UserHome/Labs/CryptoGraphy/Practical/second_lab/Decode_image.jsx';
import Corrupted from '../../Pages/Website/UserHome/Labs/CryptoGraphy/Practical/third_lab/corrupted.jsx';
import HASH_CRACK from '../../Pages/Website/UserHome/Labs/CryptoGraphy/Practical/fourth_lab/Hash_crack.jsx';
// End CryptoGraphy
// WireShark
import WireShark from '../../Pages/Website/UserHome/Labs/WireShark/WireShark.jsx';
import WIRESHARK_LAB from '../../Pages/Website/UserHome/Labs/WireShark/WireShark_lab.jsx';
import STOLEN_FLAG from '../../Pages/Website/UserHome/Labs/WireShark/Practical/third_lab/Stolen_flag.jsx';
import TCP_INTRUSION from '../../Pages/Website/UserHome/Labs/WireShark/Practical/second_lab/TCP_intrusion.jsx';
import ARP_TRICK from '../../Pages/Website/UserHome/Labs/WireShark/Practical/first_lab/ARP_trick.jsx';
// End WireShark
// File Inclusion
import FileInclusion from '../../Pages/Website/UserHome/Labs/FileInclusion/FileInclusion.jsx';
import FILEINCLUSION_LAB from '../../Pages/Website/UserHome/Labs/FileInclusion/FileInclusion_lab.jsx';
import LEARN_CAPITAL_1 from '../../Pages/Website/UserHome/Labs/FileInclusion/Practical/first_lab/Learn_capital_1.jsx';
import LEARN_CAPITAL_2 from '../../Pages/Website/UserHome/Labs/FileInclusion/Practical/second_lab/Learn_capital_2.jsx';
import LEARN_CAPITAL_3 from '../../Pages/Website/UserHome/Labs/FileInclusion/Practical/third_lab/Learn_capital_3.jsx';
// CaptchaBypass
import CaptchaBypass from '../../Pages/Website/UserHome/Labs/CaptchaBypass/CaptchaBypass.jsx';
import CAPTCHABYPASS_LAB from '../../Pages/Website/UserHome/Labs/CaptchaBypass/CaptchaBypass_lab.jsx';
import CAPTCHABYPASS_1 from '../../Pages/Website/UserHome/Labs/CaptchaBypass/Practical/Lab_1/Captcha_first.jsx';
import CAPTCHABYPASS_2 from '../../Pages/Website/UserHome/Labs/CaptchaBypass/Practical/Lab_2/Captcha_second.jsx';
import CAPTCHABYPASS_3 from '../../Pages/Website/UserHome/Labs/CaptchaBypass/Practical/Lab_3/Captcha_third.jsx';
// End CaptchaBypass

// Start UnrestrictedFileUpload
import UnrestrictedFileUpload from '../../Pages/Website/UserHome/Labs/UnrestrictedFileUpload/UnrestrictedFileUpload.jsx';
import UnrestrictedFileUploadLabs from '../../Pages/Website/UserHome/Labs/UnrestrictedFileUpload/UnrestrictedFileUploadLabs.jsx';
import UnrestrictedFirstlab from '../../Pages/Website/UserHome/Labs/UnrestrictedFileUpload/Practical/Unrestricted_Lab1.jsx';
import UnrestrictedSecondlab from '../../Pages/Website/UserHome/Labs/UnrestrictedFileUpload/Practical/Unrestricted_Lab2.jsx';
import UnrestrictedThirdlab from '../../Pages/Website/UserHome/Labs/UnrestrictedFileUpload/Practical/Unrestricted_Lab3.jsx';
// End UnrestrictedFileUpload
// Start Insecure Direct Object Reference
import InsecureDirectObjectReference from '../../Pages/Website/UserHome/Labs/IDOR/InsecureDirectObjectReference.jsx';
import InsecureDirectObjectReferenceLabs from '../../Pages/Website/UserHome/Labs/IDOR/InsecureDirectObjectReferenceLabs.jsx';
import IDORLab1 from '../../Pages/Website/UserHome/Labs/IDOR/practical/IDOR_Lab1.jsx';
import IDORLab2 from '../../Pages/Website/UserHome/Labs/IDOR/practical/IDOR_Lab2.jsx';
import IDORLab3 from '../../Pages/Website/UserHome/Labs/IDOR/practical/IDOR_Lab3.jsx';
// End Insecure Direct Object Reference
// Start Broken Authentication
import BrokenAuthentication from '../../Pages/Website/UserHome/Labs/Broken_Auth/BrokenAuthentication.jsx';
import BrokenAuthenticationLab from '../../Pages/Website/UserHome/Labs/Broken_Auth/BrokenAuthenticationLab.jsx';
import AuthLab1 from '../../Pages/Website/UserHome/Labs/Broken_Auth/Practical/Auth_lab1.jsx';
import AuthLab2 from '../../Pages/Website/UserHome/Labs/Broken_Auth/Practical/Auth_lab2.jsx';
import WordsList from '../../Pages/Website/UserHome/Labs/Broken_Auth/Practical/WordsList.js';
import AuthLab3 from '../../Pages/Website/UserHome/Labs/Broken_Auth/Practical/Auth_lab3.jsx';
import Products from '../../Pages/Website/UserHome/Labs/Broken_Auth/Practical/products.jsx';

// End Broken Authentication
// Start Path Traversal
import PathTraversal from '../../Pages/Website/UserHome/Labs/Path...Traversal/PathTraversal.jsx';
import PathTraversalLabs from '../../Pages/Website/UserHome/Labs/Path...Traversal/PathTraversalLabs.jsx';
import PathTraversalBlacklist from '../../Pages/Website/UserHome/Labs/Path...Traversal/Practical/Lab1/PathTraversalBlacklist.jsx';
import ShowProducts from '../../Pages/Website/UserHome/Labs/Path...Traversal/Practical/Lab1/ShowProducts.jsx';
import EtcPassword from '../../Pages/Website/UserHome/Labs/Path...Traversal/Practical/Lab1/passwd.jsx';
import PathTraversalMcq1 from '../../Pages/Website/UserHome/Labs/Path...Traversal/Practical/MCQ/PathTraversalMcq1.jsx';
import PathTraversalMcq2 from '../../Pages/Website/UserHome/Labs/Path...Traversal/Practical/MCQ/PathTraversalMcq2.jsx';
// End Path Traversal
// Start Command Injection
import CommandInjection from '../../Pages/Website/UserHome/Labs/CommandInjection/CommandInjection.jsx';
import CommandInjectionLabs from '../../Pages/Website/UserHome/Labs/CommandInjection/CommandInjectionLabs.jsx';
import CommandInjectionLab1 from '../../Pages/Website/UserHome/Labs/CommandInjection/Practical/CommandInjectionLab1.jsx';
import CommandInjectionLab2 from '../../Pages/Website/UserHome/Labs/CommandInjection/Practical/CommandInjectionLab2.jsx';
import CommandInjectionLab3 from '../../Pages/Website/UserHome/Labs/CommandInjection/Practical/CommandInjectionLab3.jsx';
// End Command Injection
// Start Insecure Deserialization
import InsecureDeserialization from '../../Pages/Website/UserHome/Labs/InsecureDeserialization/InsecureDeserialization.jsx';
import InsecureDeserializationLabs from '../../Pages/Website/UserHome/Labs/InsecureDeserialization/InsecureDeserializationLabs.jsx';
import InsecureDeserializationLab1 from '../../Pages/Website/UserHome/Labs/InsecureDeserialization/practical/Lab1/InsecureDeserializationLab1.jsx';
import InsecureDeserializationLab2 from '../../Pages/Website/UserHome/Labs/InsecureDeserialization/practical/Lab2/InsecureDeserializationLab2.jsx';
import TestPage from '../../Pages/Website/UserHome/Labs/InsecureDeserialization/practical/Lab1/TestPage.jsx';
import AdminDashboard from '../../Pages/Website/UserHome/Labs/InsecureDeserialization/practical/Lab1/AdminDashboard.jsx';
// End Insecure Deserialization
// Start Burp Suit
import BurpSuit from '../../Pages/Website/UserHome/Labs/Burp-Suite/BurpSuit.jsx';
import BurpSuitLabs from '../../Pages/Website/UserHome/Labs/Burp-Suite/BurpSuitLabs.jsx';
import BurpSuitLab1 from '../../Pages/Website/UserHome/Labs/Burp-Suite/Practical/Lab1/BurpSuitLab1.jsx';
import BurpSuitLab2 from '../../Pages/Website/UserHome/Labs/Burp-Suite/Practical/Lab2/BurpSuitLab2.jsx';
import BurpSuitLab3 from '../../Pages/Website/UserHome/Labs/Burp-Suite/Practical/Lab3/BurpSuitLab3.jsx';
import BurpSuitLab4 from '../../Pages/Website/UserHome/Labs/Burp-Suite/Practical/Lab4/BurpSuitLab4.jsx';
import BurpSuitDescriptions from '../../Pages/Website/UserHome/Labs/Burp-Suite/Practical/Lab3/BurpSuitDescriptions.jsx';
// End Burp Suit
//Start SSRF
import SSRF from '../../Pages/Website/UserHome/Labs/SSRF/SSRF.jsx';
import SSRFLab from '../../Pages/Website/UserHome/Labs/SSRF/SSRF_lab.jsx';
import SSRFLab1 from '../../Pages/Website/UserHome/Labs/SSRF/Practical/Lab_1/SSRF_store.jsx';
import SSRFLab2 from '../../Pages/Website/UserHome/Labs/SSRF/Practical/Lab_2/SSRF_store.jsx';
import SSRFLab1Admin from '../../Pages/Website/UserHome/Labs/SSRF/Practical/Lab_1/SSRF_admin.jsx';
import SSRFLab2Admin from '../../Pages/Website/UserHome/Labs/SSRF/Practical/Lab_2/SSRF_admin.jsx';
//End SSRF
import RaceCondition from '../../Pages/Website/UserHome/Labs/Condition_Race/RaceCondition.jsx';
import RaceConditionLabs from '../../Pages/Website/UserHome/Labs/Condition_Race/RaceConditionLabs.jsx';
import RaceConditionInRegister from '../../Pages/Website/UserHome/Labs/Condition_Race/Practical/Lab1/RC_In_Register.jsx';
import ViewRegistes from '../../Pages/Website/UserHome/Labs/Condition_Race/Practical/Lab1/ViewRegistes.jsx';
import ShoppingCart from '../../Pages/Website/UserHome/Labs/Condition_Race/Practical/Lab2/ShoppingCart.jsx';
const BashRoutes = (
  <>
    <Route
      path='/UnrestrictedFileUpload'
      element={<UnrestrictedFileUpload />}
    />
    <Route
      path='/Unrestricted File Upload/lab_Unrestricted_File_Uplode'
      element={<UnrestrictedFileUploadLabs />}
    />
    <Route
      path='/Unrestricted File Upload/lab_Unrestricted_File_Uplode/first_lab'
      element={<UnrestrictedFirstlab />}
    />
    <Route
      path='/Unrestricted File Upload/lab_Unrestricted_File_Uplode/second_lab'
      element={<UnrestrictedSecondlab />}
    />
    <Route
      path='/Unrestricted File Upload/lab_Unrestricted_File_Uplode/third_lab'
      element={<UnrestrictedThirdlab />}
    />
    {/* End Unrestricted File Upload_ */}
    {/* Start Insecure_Direct_Object_Reference */}
    <Route
      path='/Insecure_Direct_Object_Reference(IDOR)'
      element={<InsecureDirectObjectReference />}
    />
    <Route
      path='/Insecure_Direct_Object_Reference(IDOR)/Insecure_Direct_Object_Reference(IDOR)Labs'
      element={<InsecureDirectObjectReferenceLabs />}
    />
    <Route
      path='/Insecure_Direct_Object_Reference(IDOR)/Insecure_Direct_Object_Reference(IDOR)Labs/lab1'
      element={<IDORLab1 />}
    />
    <Route
      path='/Insecure_Direct_Object_Reference(IDOR)/Insecure_Direct_Object_Reference(IDOR)Labs/lab2'
      element={<IDORLab2 />}
    />
    <Route
      path='/Insecure_Direct_Object_Reference(IDOR)/Insecure_Direct_Object_Reference(IDOR)Labs/lab3'
      element={<IDORLab3 />}
    />
    {/* End Insecure_Direct_Object_Reference */}
    {/* Start Broken Authentication */}
    <Route path='/broken-auth' element={<BrokenAuthentication />} />
    <Route
      path='/broken-auth/Broken_Authentication_Lab'
      element={<BrokenAuthenticationLab />}
    />
    <Route
      path='/broken-auth/Broken_Authentication_Lab/lab1'
      element={<AuthLab1 />}
    />
    <Route path='/words-list' element={<WordsList />} />
    <Route
      path='/broken-auth/Broken_Authentication_Lab/lab2'
      element={<AuthLab2 />}
    />
    <Route
      path='/broken-auth/Broken_Authentication_Lab/lab3'
      element={<AuthLab3 />}
    />
    <Route
      path='/broken-auth/Broken_Authentication_Lab/products'
      element={<Products />}
    />
    {/* End Broken Authentication */}
    {/* Start Path Traversal */}
    <Route path='/Path__Traversal' element={<PathTraversal />} />
    <Route
      path='/Path__Traversal/Path_Traversal_Labs'
      element={<PathTraversalLabs />}
    />
    <Route
      path='/Path__Traversal/Path_Traversal_Labs/lab1'
      element={<PathTraversalBlacklist />}
    />
    <Route
      path='/Path__Traversal/Path_Traversal_Labs/lab2'
      element={<PathTraversalMcq1 />}
    />
    <Route
      path='/Path__Traversal/Path_Traversal_Labs/lab3'
      element={<PathTraversalMcq2 />}
    />
    <Route
      path='/Path__Traversal/Path_Traversal_Labs/lab1/Show_Products/:id'
      element={<ShowProducts />}
    />
    <Route
      path='/Path__Traversal/Path_Traversal_Labs/etc/passwd'
      element={<EtcPassword />}
    />
    {/* End Path Traversal */}
    {/* Start  Command Injection  */}
    <Route path='/Command_Injection' element={<CommandInjection />} />
    <Route
      path='/Command_Injection/Command_Injection_labs'
      element={<CommandInjectionLabs />}
    />
    <Route
      path='/Command_Injection/Command_Injection_labs/lab1'
      element={<CommandInjectionLab1 />}
    />
    <Route
      path='/Command_Injection/Command_Injection_labs/lab2'
      element={<CommandInjectionLab2 />}
    />
    <Route
      path='/Command_Injection/Command_Injection_labs/lab3'
      element={<CommandInjectionLab3 />}
    />
    {/* End  Command Injection  */}
    {/* Start Insecure Deserialization */}
    <Route
      path='/Insecure_Deserialization'
      element={<InsecureDeserialization />}
    />
    <Route
      path='/Insecure_Deserialization/Insecure_Deserialization_Labs'
      element={<InsecureDeserializationLabs />}
    />
    <Route
      path='/Insecure_Deserialization/Insecure_Deserialization_Labs/lab1'
      element={<InsecureDeserializationLab1 />}
    />
    <Route
      path='/Insecure_Deserialization/Insecure_Deserialization_Labs/lab1/testPage'
      element={<TestPage />}
    />
    <Route
      path='/Insecure_Deserialization/Insecure_Deserialization_Labs/lab1/AdminDashboard'
      element={<AdminDashboard />}
    />
    <Route
      path='/Insecure_Deserialization/Insecure_Deserialization_Labs/lab2'
      element={<InsecureDeserializationLab2 />}
    />
    <Route
      path='/Insecure_Deserialization/Insecure_Deserialization_Labs/lab2/testPage'
      element={<TestPage />}
    />
    <Route
      path='/Insecure_Deserialization/Insecure_Deserialization_Labs/lab2/AdminDashboard'
      element={<AdminDashboard />}
    />
    {/* End Insecure_Deserialization */}
    {/* Start Burp suit */}
    <Route path='/Burp_Suit' element={<BurpSuit />} />
    <Route path='/Burp_Suit/Burp_Suit_Labs' element={<BurpSuitLabs />} />
    <Route path='/Burp_Suit/Burp_Suit_Labs/lab1' element={<BurpSuitLab1 />} />
    <Route path='/Burp_Suit/Burp_Suit_Labs/lab2' element={<BurpSuitLab2 />} />
    <Route path='/Burp_Suit/Burp_Suit_Labs/lab3' element={<BurpSuitLab3 />} />
    <Route
      path='/Burp_Suit/Burp_Suit_Labs/lab3/:id'
      element={<BurpSuitDescriptions />}
    />
    <Route path='/Burp_Suit/Burp_Suit_Labs/lab4' element={<BurpSuitLab4 />} />
    {/* End Burp Suit */}
    {/* Start Race Condition */}
    <Route path='/Race_Condition' element={<RaceCondition />} />
    <Route
      path='/Race_Condition/Race_Condition_Labs'
      element={<RaceConditionLabs />}
    />
    <Route
      path='/Race_Condition/Race_Condition_Labs/Lab1'
      element={<RaceConditionInRegister />}
    />
    <Route path='/View Registers' element={<ViewRegistes />} />
    <Route
      path='/Race_Condition/Race_Condition_Labs/Lab2'
      element={<ShoppingCart />}
    />
    <Route path='/bash-scripting' element={<Bash />} />
    <Route path='/bash-scripting/bash_quiz' element={<BASH_QUIZ />} />
    {/* End Bash Scripting */}
    {/* Start Obfuscation */}
    <Route path='/obfuscation' element={<Obfuscation />} />
    <Route path='/Obfuscation/obfuscation_lab' element={<OBFUSCATION_LAB />} />
    <Route
      path='/Obfuscation/obfuscation_lab/login'
      element={<OBFUSCATION_LOGIN />}
    />
    <Route
      path='/Obfuscation/obfuscation_lab/quiz'
      element={<OBFUSCATION_QUIZ />}
    />
    {/* End Obfuscation */}
    {/* Start CryptoGraphy */}
    <Route path='/cryptography' element={<CryptoGraphy />} />
    <Route
      path='/cryptography/cryptography_lab'
      element={<CRYPTOGRAPHY_LAB />}
    />
    <Route
      path='/cryptography/cryptography_lab/top-secret'
      element={<TOP_SECRET />}
    />
    <Route
      path='/cryptography/cryptography_lab/decode-the-image'
      element={<DECODE_IMAGE />}
    />
    <Route
      path='/cryptography/cryptography_lab/corrupted'
      element={<Corrupted />}
    />
    <Route
      path='/cryptography/cryptography_lab/hash-crack'
      element={<HASH_CRACK />}
    />
    {/* End CryptoGraphy */}
    {/* Start WireShark */}
    <Route path='/wireshark' element={<WireShark />} />
    <Route path='/wireshark/wireshark_lab' element={<WIRESHARK_LAB />} />
    <Route
      path='/wireshark/wireshark_lab/stolen-flag'
      element={<STOLEN_FLAG />}
    />
    <Route
      path='/wireshark/wireshark_lab/tcp-intrusion'
      element={<TCP_INTRUSION />}
    />
    <Route path='/wireshark/wireshark_lab/arp-trick' element={<ARP_TRICK />} />
    {/* End WireShark */}
    {/* Start FileInclusion */}
    <Route path='/fileinclusion' element={<FileInclusion />} />
    <Route
      path='/fileinclusion/fileinclusion_lab'
      element={<FILEINCLUSION_LAB />}
    />
    <Route
      path='fileinclusion/fileinclusion_lab/Learn-the-capital-1'
      element={<LEARN_CAPITAL_1 />}
    />
    <Route
      path='fileinclusion/fileinclusion_lab/Learn-the-capital-2'
      element={<LEARN_CAPITAL_2 />}
    />
    <Route
      path='fileinclusion/fileinclusion_lab/Learn-the-capital-3'
      element={<LEARN_CAPITAL_3 />}
    />

    <Route path='/captchabypass' element={<CaptchaBypass />} />
    <Route
      path='/captchabypass/captchabypass_lab'
      element={<CAPTCHABYPASS_LAB />}
    />
    <Route
      path='/captchabypass/captchabypass_lab/lab1'
      element={<CAPTCHABYPASS_1 />}
    />
    <Route
      path='/captchabypass/captchabypass_lab/lab2'
      element={<CAPTCHABYPASS_2 />}
    />
    <Route
      path='/captchabypass/captchabypass_lab/lab3'
      element={<CAPTCHABYPASS_3 />}
    />
    <Route path='/ssrf' element={<SSRF />} />
    <Route path='/ssrf/ssrf_lab' element={<SSRFLab />} />
    <Route path='/ssrf/ssrf_lab/ssrf_lab1/store' element={<SSRFLab1 />} />
    <Route path='/ssrf/ssrf_lab/ssrf_lab2/store' element={<SSRFLab2 />} />
    <Route
      path='/ssrf/ssrf_lab/ssrf_lab1/store/admin'
      element={<SSRFLab1Admin />}
    />
    <Route
      path='/ssrf/ssrf_lab/ssrf_lab2/store/admin'
      element={<SSRFLab2Admin />}
    />
  </>
);

export default BashRoutes;
